import React from 'react';
import { releaseNotes, CURRENT_VERSION, ReleaseNote } from '../../data/releaseNotes';
import s from '../features/shared.module.css';

const CATEGORY_COLORS: Record<ReleaseNote['category'], { bg: string; border: string; text: string }> = {
  Architecture: { bg: '#eff6fc', border: '#c7e0f4', text: '#0078d4' },
  Feature:      { bg: '#dff6dd', border: '#bad80a', text: '#107c10' },
  Improvement:  { bg: '#fff4ce', border: '#ffd97d', text: '#7a5c00' },
  'Bug Fix':    { bg: '#fde7e9', border: '#f3b8a8', text: '#d13438' },
  'UI Fix':     { bg: '#f5f0fc', border: '#e0d4f0', text: '#7b3fb5' },
};

export default function ReleaseNotes() {
  return (
    <div>
      <div style={{ marginBottom: 24, padding: '16px 20px', background: '#f3f2f1', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
        <div>
          <div style={{ fontSize: 13, color: '#605e5c', marginBottom: 2 }}>Current version</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#323130', letterSpacing: '-0.5px' }}>v{CURRENT_VERSION}</div>
        </div>
        <div style={{ fontSize: 12, color: '#a19f9d' }}>
          {releaseNotes.length} releases documented
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {releaseNotes.map((release, index) => {
          const colors = CATEGORY_COLORS[release.category];
          const isLatest = index === 0;

          return (
            <div
              key={release.version}
              className={s.card}
              style={{ border: isLatest ? '1px solid #c7e0f4' : undefined }}
            >
              <div className={s.cardHeader} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 16, fontWeight: 700, color: '#323130' }}>v{release.version}</span>
                  {isLatest && (
                    <span style={{ padding: '2px 8px', background: '#0078d4', color: 'white', fontSize: 11, fontWeight: 600, borderRadius: 10 }}>
                      LATEST
                    </span>
                  )}
                  <span style={{
                    padding: '2px 8px',
                    background: colors.bg,
                    border: `1px solid ${colors.border}`,
                    color: colors.text,
                    fontSize: 11,
                    fontWeight: 600,
                    borderRadius: 10,
                  }}>
                    {release.category}
                  </span>
                </div>
                <span style={{ fontSize: 12, color: '#a19f9d', flexShrink: 0 }}>
                  {new Date(release.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                </span>
              </div>

              <div className={s.cardBody}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#323130', marginBottom: 12 }}>
                  {release.summary}
                </div>
                <ul style={{ margin: 0, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {release.changes.map((change, i) => (
                    <li key={i} style={{ fontSize: 13, color: '#605e5c', lineHeight: 1.5 }}>
                      {change}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
